var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-message"},[_c('a-icon',{attrs:{"type":"bell"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }